export enum CategoryName {
    BUNDESLIGA = 'Bundesliga',
    SECOND_BUNDESLIGA = '2. Bundesliga',
    DFB_POKAL = 'DFB-Pokal',
    INTERNATIONAL_MATCHES = 'A-Länderspiele',
    SPECIAL_FOOTBALL_PROJECTS = 'Fussball-Sonderprojekte'
}
